import pendingService from "../../../services/orders/PendingService";
import i18n from "../../../i18n/index"

export default {
  data() {
    return {
      headers: [
        {
          text: i18n.t('headers.pending-date'),
          value: "pendingDate",
          sortable: false
        },
        {
          text: i18n.t('headers.nro-order'),
          sortable: false,
          value: "numOrder"
        },
        {
          text: i18n.t('headers.document-number'),
          sortable: false,
          value: "numDocument"
        },
        {
          text: i18n.t('headers.patient-name'),
          value: "name",
          sortable: false
        },

        {
          text: i18n.t('headers.days-pending'),
          value: "daysPending",
          sortable: false
        },
        {
          text: i18n.t('headers.provider'),
          value: "provider",
          sortable: false
        }
      ],
      loading: false,
      itemsData: [],
      pagination: {},
      rowsPerPageItems: [5, 10, 15, 20],
      totalPendings: 0,
      dataPicker: false,
      date: '',
      search: ''
    }
  },
  props: {},
  watch: {
    pagination: {
      handler() {
        this.getPendingList()
      },
      deep: true
    }
  },
  methods: {
    getPendingList() {
      this.loading = true
      const { page, rowsPerPage } = this.pagination
      // let userItems = JSON.parse(localStorage.getItem('user'))
      // let userId = userItems.id
      pendingService.list(page - 1, rowsPerPage, this.date, this.search).then(response => {
        this.itemsData = response.data.pendingOrders
        this.totalPendings = response.data.count
        this.loading = false
      });
    },
    onRowClick(item) {
      this.$emit("row-click", item)
    }
  }
};
